import * as React from 'react'
import {ServiceHub} from '../../core/ServiceHub'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {connect} from 'react-redux'
import {IAppStore} from '../../interfaces/reducers'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import {LocationSelector} from './LocationSelector'
import {getDateString} from '../../core/helpers'
import {Feature} from '../../core/models'

interface ParentProps {
  onSettlementsChange: (allLocations: Feature[], selectedSettlemet?: Feature, selectedLocation?: Feature) => void
  hidePlan: boolean
  onPlanChange: (plan?: Feature) => void
}

interface OwnProps {
  layerInfos: IFeatureLayerInfos
}

type Props = OwnProps & ParentProps

interface State {
  loading: boolean
  plans: Feature[]
  error?: string
  selectedLocation?: Feature
  selectedPlan?: Feature
  selectedSettlemet?: Feature
}

class PlanSelectorClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      loading: !props.hidePlan,
      plans: []
    }
  }
  componentDidMount() {
    this.loadPlans()
  }

  loadPlans() {
    if (this.props.hidePlan) {
      return
    }
    const li = this.props.layerInfos[appConfig.reg.plan.planUrl]
    if (li && this.state.selectedLocation) {
      ServiceHub.gisCrudService
        .execute(li, {
          where: `"LocalityId" = ${this.state.selectedLocation.getId()} AND "RegPlanTypeId" IN (1,2)`,
          orderByFields: ['PlanDate DESC']
        })
        .then(r => {
          if (r.length > 0) {
            this.setState({...this.state, error: '', loading: false, plans: r, selectedPlan: r[0]}, () => {
              this.props.onPlanChange(this.state.selectedPlan)
            })
          } else {
            this.setState({...this.state, plans: [], error: '', selectedPlan: undefined, loading: false}, () => {
              this.props.onPlanChange(this.state.selectedPlan)
            })
          }
        })
        .catch(e => {
          this.setState({...this.state, error: 'Възникна грешка', loading: false})
        })
    } else {
      this.setState({...this.state, plans: [], error: '', selectedPlan: undefined, loading: false}, () => {
        this.props.onPlanChange(this.state.selectedPlan)
      })
    }
  }

  getPlans() {
    const info = this.props.layerInfos[appConfig.common.settlements.settlementsUrl]
    const locationsInfo = this.props.layerInfos[appConfig.common.locations.locationsUrl]
    const options: JSX.Element[] = [
      <option key="a" value={''}>
        Изберете план
      </option>
    ]
    if (info) {
      this.state.plans.forEach((s, i) => {
        options.push(
          <option key={i} value={s.getId()}>
            {s.get('PlanName')} от {getDateString(new Date(s.get('PlanDate')))}
          </option>
        )
      })
    }

    return (
      <select
        className="form-control"
        value={this.state.selectedPlan ? this.state.selectedPlan.getProperties()[info.sourceDescription.idField] : ''}
        onChange={e => {
          this.setState({...this.state, selectedPlan: this.state.plans.find(p => p.getId() == e.target.value)}, () => {
            this.props.onPlanChange(this.state.selectedPlan)
          })
        }}
      >
        {options}
      </select>
    )
  }

  render() {
    return (
      <div
        style={{
          position: 'relative',
          width: '100%'
        }}
      >
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        <LocationSelector
          onSettlementsChange={(locs, selectedSettlemet?: Feature, selectedLocation?: Feature) => {
            this.setState(
              {...this.state, selectedLocation: selectedLocation, selectedSettlemet: selectedSettlemet, loading: false},
              () => {
                this.props.onSettlementsChange(locs, selectedSettlemet, selectedLocation)
                this.loadPlans()
              }
            )
          }}
          selectedLocation={this.state.selectedLocation}
          selectedSettlemet={this.state.selectedSettlemet}
          hideLocations={false}
        ></LocationSelector>

        {this.props.hidePlan ? null : this.getPlans()}
      </div>
    )
  }
}

const mapStateToProps = (store: IAppStore) => ({
  layerInfos: store.layerInfos.featureLayerInfos
})

export const PlanSelector = connect<OwnProps, {}, ParentProps>(mapStateToProps)(PlanSelectorClass)
